import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { TFunction } from 'react-i18next';
import {
  Layout,
  Card,
  Stack,
  withTranslation,
} from '@piwikpro/ui-components';
import { view, errorBoundary, withInject } from '@piwikpro/platform';
import TitleComponent from '@piwikpro/title-crate/Title';
import CookiesSectionComponent from '@piwikpro/container-settings-crate/components/CookiesSection';
import CnilCompliance from './CnilCompliance';
import TdddgCompliance from './TdddgCompliance';
import { AdministrationState, STATE_ROOT } from '../../../../redux';

const mapStateToProps = (state: AdministrationState) => ({
  app: state[STATE_ROOT].apps.details.settings.settings,
});

const connector = connect(mapStateToProps);

type ReduxProps = ConnectedProps<typeof connector>;

interface Props extends ReduxProps {
  t: TFunction
  Title: typeof TitleComponent
  PrivacySettings: typeof React.Component
  SessionAndVisitorIdentifiers: typeof React.Component
  IPAnonimizationComponent: typeof React.Component
  CookiesSection: typeof CookiesSectionComponent
}

class Privacy extends React.Component<Props> {
  render() {
    const {
      app,
      t,
      Title,
      PrivacySettings,
      SessionAndVisitorIdentifiers,
      IPAnonimizationComponent,
      CookiesSection,
    } = this.props;

    return (
      <Title part={t('apps.details.tabs.privacy')}>
        <PrivacySettings />
        <Layout>
          <Layout.AnnotatedSection
            title={t('apps.details.privacy.compliances.title')}
          />
          <Layout.Column dominant>
            <Stack spacing="wide" vertical>
              <SessionAndVisitorIdentifiers />
              <Stack.Item fill>
                <Card>
                  <Card.Section>
                    <CnilCompliance />
                  </Card.Section>
                </Card>
              </Stack.Item>
              <Stack.Item fill>
                <Card>
                  <Card.Section>
                    <TdddgCompliance />
                  </Card.Section>
                </Card>
              </Stack.Item>
            </Stack>
          </Layout.Column>
        </Layout>
        <CookiesSection appId={app!.id} />
        <Layout>
          <Layout.AnnotatedSection
            title={t('apps.details.privacy.ip-addresses.title')}
          />
          <Layout.Column dominant>
            <Card>
              <IPAnonimizationComponent appId={app!.id} />
            </Card>
          </Layout.Column>
        </Layout>
      </Title>
    );
  }
}

export default connector(withInject({
  Title: 'TitleCrate.components.Title',
  PrivacySettings: 'ConsentSettingsCrate.components.PrivacySettings',
  SessionAndVisitorIdentifiers: 'ConsentSettingsCrate.components.SessionAndVisitorIdentifiers',
  IPAnonimizationComponent: 'TrackerSettingsCrate.components.AppSettings.Privacy',
  CookiesSection: 'ContainerSettingsCrate.components.CookiesSection',
})(
  view({ role: 'USER', level: 'view' }, true)(withTranslation(['administration'])(errorBoundary(Privacy))),
));
